import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M19.791 12h-6.875v-1.834h1.834A3.67 3.67 0 0 0 18.416 6.5V4.666A3.67 3.67 0 0 0 14.75 1h-5.5a3.67 3.67 0 0 0-3.667 3.666V6.5a3.67 3.67 0 0 0 3.667 3.666h1.833V12H1.917a.916.916 0 1 0 0 1.833h.916v8.25a.916.916 0 1 0 1.833 0v-8.25H14.75v5.958c0 1.77 1.439 3.209 3.208 3.209h1.833C21.561 23 23 21.56 23 19.79v-4.583C23 13.438 21.56 12 19.79 12M7.416 6.5V4.666c0-1.01.823-1.833 1.834-1.833h5.5c1.01 0 1.833.822 1.833 1.833V6.5a1.835 1.835 0 0 1-1.833 1.833h-5.5A1.835 1.835 0 0 1 7.416 6.5m12.375 7.333c.758 0 1.375.617 1.375 1.375v1.375h-4.583v-2.75zm0 7.333h-1.833a1.377 1.377 0 0 1-1.375-1.375v-1.375h4.583v1.375c0 .758-.617 1.375-1.375 1.375"
    }, null, -1)
  ]))]))
}
export default { render: render }